import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/brand.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { pruneBackups } from "./utils/backupRetention";

// Clear old session backups before anything else writes: a full localStorage made every save
// throw and the app crash. A sedation in progress is among the most recently backed up, so it is
// always inside the kept set.
for (const storage of [window.localStorage, window.sessionStorage]) {
  try {
    pruneBackups(storage);
  } catch {
    // storage unavailable: nothing to prune
  }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
